<template>
	<div class="container">
		<div class="main_box">
			<!--块1-->
			<div class="block_1">
				<div class="tit_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="cn">荣誉资质</div>
					<div class="en">Honors & Certificates</div>
				</div>
				<div class="block_1_main"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="block_banner">
						<van-swipe
							class=""
							:loop="false"
							:autoplay="3000"
							indicator-color="white"
							:stop-propagation="false"
							:show-indicators="false"
							:width="280"
						>
							<van-swipe-item v-for="(value2, index2) in listDataCn" :key="index2" @click="showBigImg(value2.image)">
								<div class="block_main">
									<img class="img_el" lazy-load :src="value2.image" />
									<div v-if="value2.title" class="tit">{{ value2.title }}</div>
								</div>
							</van-swipe-item>
						</van-swipe>
					</div>
				</div>
			</div>
			<!--块1-->
		</div>
	</div>
</template>

<script>
import { ImagePreview } from 'vant';  //图片放大
export default {
	components:{
		//
	},
	data() {
		return {
			listDataCn: [
				{ image: require('@/assets/img_public/about/ryzz/cn/1.webp'), title: '企业资质-安全生产标准化' },
				{ image: require('@/assets/img_public/about/ryzz/cn/2.png'), title: '企业资质-高新技术企业' },
				{ image: require('@/assets/img_public/about/ryzz/cn/3.webp'), title: '企业资质-质量管理体系认证' },
				{ image: require('@/assets/img_public/about/ryzz/cn/4.webp'), title: '企业资质-中关村高新技术企业' },
				{ image: require('@/assets/img_public/about/ryzz/cn/5.webp'), title: '企业资质-专精特新' },
				{ image: require('@/assets/img_public/about/ryzz/cn/6.webp'), title: '企业资质-CA' }
			],
			listDataEn: [
				{ image: require('@/assets/img_public/about/ryzz/en/1.webp'), title: '' },
				{ image: require('@/assets/img_public/about/ryzz/en/2.webp'), title: '' },
				{ image: require('@/assets/img_public/about/ryzz/en/3.webp'), title: '' },
				{ image: require('@/assets/img_public/about/ryzz/en/4.webp'), title: '' },
				{ image: require('@/assets/img_public/about/ryzz/en/5.webp'), title: '' },
				{ image: require('@/assets/img_public/about/ryzz/en/6.webp'), title: '' },
				{ image: require('@/assets/img_public/about/ryzz/en/7.webp'), title: '' },
			]
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//查看大图
		showBigImg(value) {
			let that = this;
			ImagePreview({
				closeable: true,
				showIndicators: false,
				showIndex: false,
				images: [value]
			});
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块1
	.block_1{
		padding: 40px 0 40px 20px;
		.block_1_main{
			padding-top: 40px;
			.block_banner{
				position: relative;
				.block_main{
					margin-right: 20px;
					padding: 20px;
					background-color: #F7F6F9;
					.tit{
						padding-top: 20px;
						text-align: center;
					}
					.img_el{
						width: 100%;
						border-radius: 8px;
					}
				}
			}
		}
		.tit_box{
			text-align: center;
			.en{
				padding-top: 0px;
			}
			.cn{
				font-size: 24px;
				font-weight: bold;
			}
		}
	}
}
</style>